export default {
  pageTitle: 'Value Chain workflow hub',
  recentValueChainMaps: 'Recent value chain maps',
  showAll: 'Show all',
  yourTasks: 'Your tasks',
  materialityAssessment: 'Materiality assessment',
  open: 'Open',
  sampleCardOne: 'Sample card 1',
  sampleCardTwo: 'Sample card 2',
  stageNum: 'Stage {{num}}',
  phase0: {
    title: 'Phase 0 — Foundation loaded',
    description: 'Stage config, icons, and i18n are ready. Hub UI arrives in Phase 1.',
    lanes: '{{count}} workflow rows',
    tiles: '{{count}} tiles',
    compareHint: 'Compare with the current launchpad at /launchpad',
  },
  tileDisabled: '{{name}} — Module disabled: Please contact Customer Success',
  mustCreateValueChain: 'You must create a Value Chain in order to proceed',
  activeValueChain: {
    emptyList: 'No Value Chain Maps available. Use Map to create one.',
  },
  lanes: {
    visualize: {
      title: 'Visualize',
      subtitle: 'Map and explore your value chain',
    },
    understand: {
      title: 'Understand',
      subtitle: 'Financial, regulatory and climate context',
    },
    plan: {
      title: 'Plan',
      subtitle: 'Scenarios and prioritization',
    },
    act: {
      title: 'Act / Resilience',
      subtitle: 'Awareness, sourcing and competition',
    },
    reporting: {
      title: 'Reporting Hub + Insights',
      subtitle: 'Reports and materiality',
    },
  },
  tiles: {
    map: 'Map',
    discover: 'Discover',
    collaborate: 'Collaborate',
    finance: 'Finance',
    reputation: 'Reputation',
    ownership: 'Ownership',
    regulation: 'Regulation',
    climate: 'Climate',
    scenario: 'Scenario',
    prioritize: 'Prioritize',
    awareness: 'Situational Awareness',
    sourcing: 'Sourcing',
    competitors: 'Competitors',
    boardReport: 'Board Report',
    execSummary: 'Executive Summary',
    reportBuilder: 'Report Builder',
    templatedReports: 'Templated Reports',
    materiality: 'Materiality Assessment',
  },
  discover: {
    title: 'Discover Value Chain',
    body: 'Proceed loading the default Value Chain, or select it in the dropdown',
    mapLabel: 'Value Chain Map',
    cancel: 'Cancel',
    confirm: 'Confirm',
    emptyList: 'No Value Chain Maps available',
  },
  splash: {
    welcomeUser: 'Welcome, {{name}}',
    loading: 'Loading your workspace…',
  },
  indicatorsPanel: {
    ariaLabel: 'Workflow summary indicators',
    stageSubtitle: 'Summary indicators across Stage {{num}}',
    reportingSubtitle: 'Summary indicators for reporting and insights',
    chevronLabel: '{{title}} indicators',
    impactHorizon: 'Impact horizon',
    impacts: 'impacts',
    indicators: {
      visualize: {
        map: {
          mappedEntities: 'Mapped entities',
          tierCoverage: 'Tier coverage',
          geoNodes: 'Geo nodes',
          lastSync: 'Last sync',
        },
        discover: {
          sessions: 'Discovery sessions',
          newLinks: 'New links suggested',
          highConfidence: 'Confidence > 80%',
          pendingReview: 'Pending review',
        },
        collaborate: {
          contributors: 'Active contributors',
          comments: 'Comments (7d)',
          workspaces: 'Shared workspaces',
          openTasks: 'Open tasks',
        },
      },
      understand: {
        finance: {
          ownedProducts: 'Owned products impacted',
          revenueExposure: 'Revenue exposure',
          clientsImpacted: 'Clients impacted',
          supplierTiers: 'Supplier tiers origin',
        },
        reputation: {
          riskSignals: 'Risk signals active',
          sentimentIndex: 'Sentiment index',
          mediaMentions: 'Media mentions (30d)',
          clientSegments: 'Client segments monitored',
        },
        ownership: {
          parentEntities: 'Ultimate parent entities',
          disclosedOwnership: 'Disclosed ownership',
          crossHoldings: 'Cross-holdings flagged',
          jurisdictions: 'Jurisdictions',
        },
        regulation: {
          activeRegulations: 'Active regulations tracked',
          highImpact: 'High-impact obligations',
          entitiesAffected: 'Entities affected',
          complianceGaps: 'Compliance gaps open',
          horizons: {
            threeMo: '3 mo',
            sixMo: '6 mo',
            nineMo: '9 mo',
            twelveMo: '12 mo',
          },
        },
        climate: {
          alignmentGap: 'Portfolio alignment gap',
          scope3Hotspots: 'Scope 3 hotspots',
          physicalRiskSites: 'Physical risk sites',
          suppliersWithTargets: 'Suppliers with targets',
        },
      },
      plan: {
        scenario: {
          modeled: 'Scenarios modeled',
          sensitivityRuns: 'Sensitivity runs',
          stressPathways: 'Stress pathways',
          bestFitRoute: 'Best-fit route',
        },
        prioritize: {
          initiativesRanked: 'Initiatives ranked',
          highPriority: 'High-priority items',
          expectedRoi: 'Expected ROI',
          ownerAssigned: 'Owner assigned',
        },
      },
      act: {
        awareness: {
          liveAlerts: 'Live alerts',
          criticalWatchpoints: 'Critical watchpoints',
          escalations: 'Escalations (30d)',
          responseSla: 'Response SLA',
        },
        sourcing: {
          alternativeSuppliers: 'Alternative suppliers',
          dualSourceCoverage: 'Dual-source coverage',
          avgLeadTime: 'Avg lead time',
          contractRenewals: 'Contract renewals',
        },
        competitors: {
          benchmarkedPeers: 'Benchmarked peers',
          capabilityGaps: 'Capability gaps',
          threatSignals: 'Threat signals',
          opportunityFlags: 'Opportunity flags',
        },
      },
      reporting: {
        boardReport: {
          latestVersion: 'Latest version',
          sectionsComplete: 'Sections complete',
          reviewComments: 'Review comments',
          approvalStatus: 'Approval status',
        },
        execSummary: {
          drafts: 'Generated drafts',
          avgReadTime: 'Avg read time',
          recipients: 'C-level recipients',
          openActions: 'Open action items',
        },
        reportBuilder: {
          reusableBlocks: 'Reusable blocks',
          templateVariants: 'Template variants',
          dataSources: 'Data sources linked',
          syncFreshness: 'Sync freshness',
        },
        templatedReports: {
          published: 'Templates published',
          autoSchedules: 'Auto schedules',
          exportFormats: 'Export formats',
          deliverySuccess: 'Delivery success',
        },
        materiality: {
          activeAssessments: 'Active assessments',
          stakeholdersMapped: 'Stakeholders mapped',
          topicsScored: 'Topics scored',
          lastPublication: 'Last publication',
        },
      },
    },
  },
};
